import { MessageListItemContentType } from '../../messages';
export const COLUMN_SORT_STATE_PREFIX = 'sdColumnSortState-';
export const COLUMN_SORT_STATE = COLUMN_SORT_STATE_PREFIX + '20240428';
export enum ColumnName {
	MarketDepth, // تابلو
	ContractInfo, // اطلاعات قرارداد
	TrendChart, // نمودار
	IndInsChart, //  حقیقی و حقوقی
	TradingChart, // روند معاملات حقیقی
	Analytics, // ارزسابی نماد
	ReturnChart, // بازده
	SymbolInfo // اطلاعات نماد
}

export enum MarketGroup {
	One = 'One',
	Two = 'Two',
	Three = 'Three',
	Four = 'Four',
	Five = 'Five'
}
export interface ColumnState {
	index: number;
	id: number;
	name: string;
	pinned: boolean;
	title: string;
	isExpand: boolean;
}
export interface MarketGroupLisItem {
	key: string;
	index: number;
}

export type MarketGroupList = MarketGroupLisItem[];

export const SYMBOL_DETAILS_OPTIONS: ColumnState[] = [
	{
		index: ColumnName.MarketDepth,
		id: ColumnName.MarketDepth,
		name: ColumnName[ColumnName.MarketDepth],
		pinned: true,
		title: 'تابلو',
		isExpand: true
	},
	{
		index: ColumnName.TrendChart,
		id: ColumnName.TrendChart,
		name: ColumnName[ColumnName.TrendChart],
		pinned: false,
		title: 'نمودار',
		isExpand: true
	},
	{
		index: ColumnName.IndInsChart,
		id: ColumnName.IndInsChart,
		name: ColumnName[ColumnName.IndInsChart],
		pinned: false,
		title: 'حقیقی و حقوقی',
		isExpand: true
	},
	{
		index: ColumnName.TradingChart,
		id: ColumnName.TradingChart,
		name: ColumnName[ColumnName.TradingChart],
		pinned: false,
		title: 'روند معاملات حقیقی',
		isExpand: true
	},
	{
		index: ColumnName.Analytics,
		id: ColumnName.Analytics,
		name: ColumnName[ColumnName.Analytics],
		pinned: false,
		title: 'ارزیابی نماد',
		isExpand: true
	},
	{
		index: ColumnName.ReturnChart,
		id: ColumnName.ReturnChart,
		name: ColumnName[ColumnName.ReturnChart],
		pinned: false,
		title: 'بازدهی',
		isExpand: true
	},
	{
		index: ColumnName.SymbolInfo,
		id: ColumnName.SymbolInfo,
		name: ColumnName[ColumnName.SymbolInfo],
		pinned: false,
		title: 'اطلاعات تکمیلی',
		isExpand: true
	},
	{
		index: ColumnName.ContractInfo,
		id: ColumnName.ContractInfo,
		name: ColumnName[ColumnName.ContractInfo],
		pinned: false,
		title: 'اطلاعات قرارداد',
		isExpand: true
	}
];

type Icons = { [key: number]: string };
export const ICONS = {
	[MessageListItemContentType.ArzeAvalie]: 'mdi-numeric-1-box text-muted',
	[MessageListItemContentType.Goshayesh]: 'mdi-play-circle text-success',
	[MessageListItemContentType.TavaghofNamad]: 'mdi-stop-circle text-danger',
	[MessageListItemContentType.PazireNevisi]: 'mdi-play-circle text-success',
	[MessageListItemContentType.DamaneMojaz]: 'mdi-play-circle text-success',
	[MessageListItemContentType.Omde]: 'mdi-dots-horizontal-circle text-muted',
	[MessageListItemContentType.SarResid]: 'mdi-stop-circle text-danger',
	[MessageListItemContentType.BazGoshayi]: 'mdi-play-circle text-success',
	[MessageListItemContentType.Ettelaeeye]: 'mdi-dots-horizontal-circle text-success',
	[MessageListItemContentType.Bazargardani]: 'mdi-dots-horizontal-circle text-success',
	[MessageListItemContentType.Haraj]: 'mdi-play-circle text-success',
	[MessageListItemContentType.RafeeGere]: 'mdi-skip-next-circle text-muted',
	[MessageListItemContentType.EstefadeNashode]: 'mdi-alert-circle text-muted',
	[MessageListItemContentType.Maskan]: 'mdi-home-circle text-muted',
	[MessageListItemContentType.Other]: 'mdi-dots-horizontal-circle text-muted'
} as Icons;
